import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import compose from 'recompose/compose'

// Material UI
import { withTheme } from '@material-ui/core/styles'

// Components

// Utils
import { Typography } from '@material-ui/core'
import Utils from '../resources/Utils'
import LogsPaymentsUsersTable from '../components/LogsPaymentsUsersTable'
class LogsPaymentsUsersList extends Component {
  render() {
    return (
      <div>
        <Typography><h2>{Utils.getMessages().logsUsersPaymentsMessages.title}</h2></Typography>
        <LogsPaymentsUsersTable/>
      </div>
    )
  }
}

const mapStateToProps = state => ({ ...state })

export default compose(
  withRouter,
  withTheme,
  connect(mapStateToProps)
)(LogsPaymentsUsersList)
